import React, { useState, useEffect, useRef } from 'react'
import { Panel, IconButton, Icon, Placeholder, Loader } from 'rsuite'
// import ReactPDF from '@react-pdf/renderer'
// import PdfFile from './PdfFile'

import { pdfjs, Document, Page } from 'react-pdf'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

export default function PdfRenderWidgets(props) {
  const {
    header,
    isShaded = true,
    isShowbutton = true,
    fileName,
    file,
    isLoading,
    onReload,
    loadingMessage,
    firstExpandToReload,
  } = props
  const [numPages, setNumPages] = useState(null)
  const { Paragraph, Graph } = Placeholder

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages)
  }

  const containerRef = useRef(null)
  const [containerWidth, setContainerWidth] = useState(0)
  const [windowWidth, setWindowWidth] = useState(0)

  const handleResize = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth)
    }
  }, [containerRef, windowWidth])

  const onDownload = async (fileObj) => {
    // console.log('fileObj', fileObj)
    const url = window.URL.createObjectURL(fileObj)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName || 'preview_PDF')
    document.body.appendChild(link)
    link.click()
  }

  return (
    <>
      <div ref={containerRef}>
        <Panel
          header={header ? 'แสดงตัวอย่าง ' + header : 'แสดงตัวอย่างก่อนพิมพ์'}
          shaded={isShaded}
          bordered
          style={{ marginTop: 10, overflowX: 'scroll' }}
          collapsible
          defaultExpanded={!firstExpandToReload}
          onSelect={() => {
            if (!file) {
              firstExpandToReload && onReload && onReload()
            }
          }}
          // id="panelPdf"
        >
          {isShowbutton && (
            <>
              <IconButton
                appearance="ghost"
                style={{ marginRight: 15 }}
                icon={<Icon icon="download" className="bt-gost-icon-radius" />}
                onClick={(e) => onDownload(file)}
                disabled={!file || isLoading}
              >
                {'ดาวน์โหลด'}
              </IconButton>

              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-info"
                icon={<Icon icon="refresh" className="bt-gost-icon-radius-info" />}
                onClick={(e) => onReload()}
                disabled={!onReload || isLoading}
              >
                {'reload'}
              </IconButton>
            </>
          )}

          {isLoading ? (
            <div>
              <p style={{ marginTop: 10 }}>
                {loadingMessage || 'กรุณารอสักครู่ ระบบกำลังสร้าง PDF ...'}
                <Loader />
              </p>
              <Paragraph rows={20} />
            </div>
          ) : (
            <Document
              file={file}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={(e) => {
                console.log('onLoadError', e)
              }}
              noData={'ไม่พบไฟล์ PDF'}
            >
              {Array.apply(null, Array(numPages))
                .map((x, i) => i + 1)
                .map((page) => (
                  <Page
                    pageNumber={page}
                    wrap={true}
                    key={page}
                    width={containerWidth > 500 ? containerWidth - 50 : 350}
                  />
                ))}
            </Document>
          )}
        </Panel>
      </div>
    </>
  )
}
